import { render, staticRenderFns } from "./LogDetailsDialog.vue?vue&type=template&id=183dc551&scoped=true"
import script from "./LogDetailsDialog.vue?vue&type=script&lang=ts"
export * from "./LogDetailsDialog.vue?vue&type=script&lang=ts"
import style0 from "./LogDetailsDialog.vue?vue&type=style&index=0&id=183dc551&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183dc551",
  null
  
)

export default component.exports